import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROUTES } from '../../lib/constants';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // ONLY show the full screen blocker on the first initialization
  // If we already have confirmation of auth state, let layout remain stable
  if (loading && !isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-cream-50 via-cream-100 to-brown-50 flex items-center justify-center p-4 animate-fade-in">
        <div className="text-center">
          <Loader2 className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-brown-600 animate-spin mx-auto mb-3 sm:mb-4" />
          <p className="text-sm sm:text-base md:text-lg text-brown-700 font-medium">
            Securing environment...
          </p>
        </div>
      </div>
    );
  }

  // If loading is done and user is definitely not signed in, route to authentication page
  if (!loading && !isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // Fallback graceful safety handling: if state is checking silently in background, 
  // do not drop the structural components, preserve the DOM structure tree layout.
  return children;
};

export default ProtectedRoute;